import React from 'react';
import { IIconProps } from '../IIconProps';

export const ModalQuestionIcon = ({
	iconClass = '',
	title = '',
}: IIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 56 46"
			className={iconClass}
			fill="none"
		>
			{title && <title>{title}</title>}
			<path
				d="M28.7143 30.0902V32M28.7129 27.1647V27.1223C28.6771 26.4831 28.7686 24.6093 29.6086 23.6234L30.9443 22.3025C32.0014 21.3415 33 20.4317 33 19.1196C33 17.7618 32.4732 16.4596 31.5355 15.4995C30.5979 14.5394 29.3261 14 28 14C26.6739 14 25.4021 14.5394 24.4645 15.4995C23.5268 16.4596 23 17.7618 23 19.1196M28 5C32.7739 5 37.3523 6.89642 40.7279 10.2721C44.1036 13.6477 46 18.2261 46 23C46 27.7739 44.1036 32.3523 40.7279 35.7279C37.3523 39.1036 32.7739 41 28 41C23.2261 41 18.6477 39.1036 15.2721 35.7279C11.8964 32.3523 10 27.7739 10 23C10 18.2261 11.8964 13.6477 15.2721 10.2721C18.6477 6.89642 23.2261 5 28 5Z"
				stroke="#2C3171"
			/>
		</svg>
	);
};
